import { FC } from 'react';
import { Skeleton, Alert } from 'antd';

interface PdfPreviewPaneProps {
  isBusy: boolean;
  error?: string | null;
  previewUrl: string | null;
  height: number;
  backgroundColor: string;
  borderColor: string;
}

const PdfPreviewPane: FC<PdfPreviewPaneProps> = ({
  isBusy,
  error,
  previewUrl,
  height,
  backgroundColor,
  borderColor,
}) => {
  if (isBusy) {
    return <Skeleton active style={{ width: '100%', height }} />;
  }

  if (error) {
    return <Alert title={error} type="error" showIcon />;
  }

  if (previewUrl) {
    return (
      <div
        style={{
          width: '100%',
          height,
          backgroundColor,
          border: `1px solid ${borderColor}`,
        }}
      >
        <iframe
          src={`${previewUrl}#toolbar=0&navpanes=0&scrollbar=0&view=FitH`}
          title="PDF Preview"
          style={{
            width: '100%',
            height: '100%',
            border: 'none',
          }}
        />
      </div>
    );
  }

  return (
    <div style={{ width: '100%' }}>
      Select a view mode to generate a preview.
    </div>
  );
};

export default PdfPreviewPane;

